import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { CustomButton } from "../../../components/common/customButton";

type DealSummaryEditDialogProps = {
  open: boolean;
  title: string;
  value: string;
  saving: boolean;
  onChange: (value: string) => void;
  onCancel: () => void;
  onSave: () => void;
};

export function DealSummaryEditDialog({
  open,
  title,
  value,
  saving,
  onChange,
  onCancel,
  onSave,
}: DealSummaryEditDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onCancel}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          fullWidth
          multiline
          rows={20}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          variant="outlined"
          sx={{ mt: 2 }}
          disabled={saving}
        />
      </DialogContent>
      <DialogActions>
        <CustomButton
          text="Cancel"
          handleButtonPress={onCancel}
          solid={false}
          isButtonDisabled={saving}
        />
        <CustomButton
          text={saving ? "Saving..." : "Save"}
          handleButtonPress={onSave}
          solid={true}
          isButtonDisabled={saving}
        />
      </DialogActions>
    </Dialog>
  );
}
